import { Link } from "react-router-dom";
import { preload } from "react-dom";
import { ArrowRight } from "lucide-react";
import { showMedia } from "@/lib/content";
import { t } from "@/lib/i18n";
import Photo, { srcSetOf } from "@/components/Photo";
import { path } from "@/lib/routes";

export default function Hero({ content, isPreview }) {
  const img = content?.media?.hero;
  const withImg = showMedia(img, isPreview);
  if (withImg) preload(img.src, { as: "image", fetchPriority: "high", imageSrcSet: srcSetOf(img, img.avif ? "avif" : "variants"), imageSizes: "100vw", type: img.avif ? "image/avif" : undefined });
  return (
    <section className="hero-min relative isolate overflow-hidden bg-forest min-h-[calc(100svh-76px)] lg:min-h-[calc(100svh-88px)] flex items-end" data-testid="home-hero">
      {withImg && (
        <>
          <Photo img={img} eager isPreview={isPreview} sizes="100vw" className="absolute inset-0 -z-10" imgClassName="hero-img" badgeClass="top-4 right-4" />
          <div className="absolute inset-0 -z-10 bg-gradient-to-t from-[#0E1D15]/95 via-[#13261C]/60 to-[#13261C]/25" aria-hidden="true" />
          <div className="absolute inset-0 -z-10 hidden md:block bg-gradient-to-r from-[#0E1D15]/70 via-[#13261C]/20 to-transparent" aria-hidden="true" />
        </>
      )}
      <div className="safe-x max-w-7xl mx-auto w-full pb-16 pt-28 sm:pb-24 lg:pb-28">
        <div className="max-w-3xl">
          <p className="eyebrow !text-gold-light mb-6 fade-in">{t("hero.eyebrow")}</p>
          <h1 className="text-[2.75rem] leading-[1.02] sm:text-6xl lg:text-7xl font-semibold text-cream" data-testid="hero-title">
            {t("hero.title")}
          </h1>
          <p className="mt-6 max-w-xl text-base sm:text-lg leading-relaxed text-cream/90 fade-in" style={{ animationDelay: "180ms" }} data-testid="hero-text">
            {t("hero.text")}
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-3 fade-in" style={{ animationDelay: "280ms" }}>
            <Link to={path("kesfet")} className="group inline-flex items-center justify-center gap-2 min-h-[52px] px-7 rounded-full bg-gold-light text-forest-dark font-semibold hover:bg-[#F0D8A6] transition-colors" data-testid="hero-kesfet-button">
              {t("hero.primary")}
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" />
            </Link>
            <Link to={path("ziyaret")} className="inline-flex items-center justify-center min-h-[52px] px-7 rounded-full border border-cream/60 text-cream font-semibold hover:bg-white/10 transition-colors" data-testid="hero-ziyaret-button">
              {t("hero.secondary")}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
